"use strict";

import axios from '@/plugins/axios';

export const location = {
    namespaced: true,
    state: {
        locations: []
    },
    getters: {
        getLocations: state => state.locations
    },
    mutations: {
        UPDATE_LOCATIONS: (state, payload) => state.locations = payload
    },
    actions: {
        async getLocations({ commit }) {
            try {
                let res = (await axios.get('/api/locations')).data;

                if (res.success) commit('UPDATE_LOCATIONS', res.data)
            } catch (error) {

                return error
            }
        },
        async createLocation({ state }, payload) {
            try {
                let res = (await axios.post('/api/locations', payload)).data;
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
                if (res.success) { state.locations.unshift(res.data); return true }
                else return false
            } catch (error) {
                return error

            }
        },
        async deleteLocation({ state }, payload) {
            try {

                let res = (await axios.delete(`/api/locations`, { params: { id: payload._id } })).data;

                if (res.success) state.locations.splice(state.locations.findIndex(location => location._id === payload._id), 1)
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                return error

            }
        },
        async uploadImage(_context, payload) {
            try {

                let res = (
                    await axios.post("api/location/uploadImage", payload, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                ).data;
                if (res.success) return res.data
                else window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) { return error; }
        },
    }
}